export const NairaSymbol = "₦";

export const formatNumberMax = (num: number): string => {
  if (num >= 1000000) {
    return (num / 1000000).toFixed(num % 1000000 === 0 ? 0 : 1) + "M";
  } else if (num >= 1000) {
    return (num / 1000).toFixed(num % 1000 === 0 ? 0 : 1) + "k";
  }
  return num.toString();
};


export function formatCurrencyLocal(amount: number) {
  if (isNaN(amount)) {
    amount = 0;
    // throw new Error("Invalid amount provided.");
  }
  return `${NairaSymbol}${Number(amount).toLocaleString("en-NG", {
    minimumFractionDigits: 2,
    maximumFractionDigits: 2,
  })}`;
}